import { type FunctionComponent, useState } from 'react';

import { captureException } from '@sentry/react';

import MessageModal from 'components/admin/MessageModal';

import { removeResearchLibLink } from 'services/researchLib';
import { useGlobalStateObject } from 'utils';

type PropsT = {
  linkId: string;
  onCancel: () => void;
};

export const RemoveLinkModal: FunctionComponent<PropsT> = ({
  linkId,
  onCancel,
}) => {
  const [busy, setBusy] = useState(false);

  const gs = useGlobalStateObject();

  return (
    <MessageModal
      busy={busy}
      cancelButtonLabel="No, cancel"
      confirmButtonLabel="Yes, remove"
      icon="WARN"
      onCancel={onCancel}
      onConfirm={() => {
        void (async () => {
          try {
            setBusy(true);

            await removeResearchLibLink(linkId);

            let list = gs.get('researchLib.links.data');
            if (!list) throw Error('Internal error');

            const idx = list.findIndex((item) => item.id === linkId);
            if (idx < 0) throw Error('Internal error');

            list = [...list];
            list.splice(idx, 1);
            gs.set('researchLib.links.data', list);

            onCancel();
          } catch (error) {
            captureException(error);

            // eslint-disable-next-line no-alert
            alert('Failed to remove the link');
          } finally {
            setBusy(false);
          }
        })();
      }}
    >
      <h1>Are you sure you want to remove this link?</h1>
      <p>This action cannot be undone.</p>
    </MessageModal>
  );
};
